import Filter from './filter';

export default Filter((FILTER_TYPES) => ({
  id: 'RESTAURANT',
  analyticsName: 'Restaurant',
  queryKey: 'f_restaurant',
  type: FILTER_TYPES.BOOLEAN,
  bucketify: (hotel) => {
    const facts = hotel?.hotelFacts;

    if (!facts?.length) {
      return {
        bucketId: FILTER_TYPES.BINARY_BUCKET.FALSE,
        bucketName: 'restaurant',
      };
    }

    for (let i = 0; i < facts.length; i += 1) {
      const fact = facts[i];

      if (fact && fact.id === 'restaurants') {
        return {
          bucketId: fact.filterValue ? FILTER_TYPES.BINARY_BUCKET.TRUE : FILTER_TYPES.BINARY_BUCKET.FALSE,
          bucketName: 'restaurant',
        };
      }
    }

    return {
      bucketId: FILTER_TYPES.BINARY_BUCKET.FALSE,
      bucketName: 'restaurant',
    };
  },
  toQuery: ({ value }) => {
    return value ? 1 : undefined;
  },
  fromQuery: (rawQueryValue) => {
    return {
      [FILTER_TYPES.BINARY_BUCKET.TRUE]: !!rawQueryValue,
    };
  },
}));
